import ListTodo from './todos/ListTodo';
import ToastExample from './todos/Toast/ToastExample';
function App() {
  return (
    <div className="App">
      <ListTodo/>
      <ToastExample/>
    </div>
    
    
  );
  
}

export default App;